import { usePost } from '../../HttpClient';
import { CreateRateRequest, CreateRateResponse } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useCreateBankOfEnglandBaseRate() {
  const post = usePost(true, "tms");
  const addBankOfEnglandBaseRate = (request: CreateRateRequest): Promise<CreateRateResponse> =>
    post(`${referenceDataBaseUrl}/rate-types/BOE/rates`, request);
  return useMutationWithErrorHandling({
    mutationFn: async (request: CreateRateRequest) => await addBankOfEnglandBaseRate(request),
  });
}
